import { useCallback, useEffect, useState } from 'react';
import * as apiObject from 'api/apiObjects';
import type { HistoryPriceRow } from './types';

export const useHistoryPrice = (objectId: number | null | undefined, show: boolean) => {
    const [history, setHistory] = useState<HistoryPriceRow[]>([]);
    const [loading, setLoading] = useState(false);

    const reload = useCallback(async () => {
        if (!objectId) {
            setHistory([]);
            return;
        }
        setLoading(true);
        const rows = await apiObject.getPriceHistory(objectId);
        setHistory(Array.isArray(rows) ? rows : []);
        setLoading(false);
    }, [objectId]);

    useEffect(() => {
        if (!show || !objectId) return;
        void reload();
    }, [show, objectId, reload]);

    return { history, loading, reload };
};
